import React from 'react'
import ChevronRight from '@material-ui/icons/ChevronRight'

const TrucksProduction = props => {
  const newDrivers = [
    ...new Set(
      props.activeNow.activeData.reduce((acc, cur) => {
        if (cur.driverLicencePlate) {
          acc.push(cur.driverLicencePlate)
        }
        return acc
      }, [])
    )
  ]

  return (
    <div style={{ paddingTop: '24px' }}>
      {props.activeNow.signOnOffData.map((driver, i) => {
        const loads = props.activeNow.activeData.filter(item => item.driverId === driver.driverId)
          .length
        const hauls = props.activeNow.signOnOffData.filter(
          data => data.driverId === driver.driverId
        ).length
        return (
          <div key={i} style={i > 0 ? { marginTop: '16px' } : {}}>
            <div
              style={{ height: '92px', boxShadow: '0px 1px 3px #00000029', borderRadius: '5px' }}
              onClick={() => props.handleDriverPress(driver)}
            >
              <div
                style={{
                  backgroundColor: '#F6F9FD',
                  height: '35px',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <span style={{ fontSize: '16px', color: '#3E3E41', paddingLeft: '16px' }}>
                  {driver.truckId}
                </span>
              </div>
              <div style={{ display: 'flex', height: '52px' }}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '20%',
                    justifyContent: 'center',
                    paddingLeft: '16px',
                    borderRight: '1px solid #E7E7EC',
                    marginTop: '5px'
                  }}
                >
                  <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Loads</span>
                  <span style={{ fontSize: '16px', color: '#3E3E41', paddingTop: '6px' }}>
                    {loads}
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '20%',
                    justifyContent: 'center',
                    paddingLeft: '16px',
                    borderRight: '1px solid #E7E7EC',
                    marginTop: '5px'
                  }}
                >
                  <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Hauls</span>
                  <span style={{ fontSize: '16px', color: '#3E3E41', paddingTop: '6px' }}>
                    {hauls}
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    paddingLeft: '16px',
                    marginTop: '5px',
                    width: '50%'
                  }}
                >
                  <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Driver</span>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-end'
                    }}
                  >
                    <span style={{ fontSize: '16px', color: '#3E3E41' }}>
                      {driver.firstName} {driver.lastName}
                    </span>
                    <ChevronRight style={{ color: '#9FA0A5' }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      })}
      {/* loads that have been added manually but not yet assigned to a driver */}
      {newDrivers.map((driver, i) => {
        const loads = props.activeNow.activeData.filter(item => item.driverLicencePlate === driver)
          .length
        const hauls = 1
        return (
          <div key={i} style={{ marginTop: '16px' }}>
            <div
              style={{ height: '92px', boxShadow: '0px 1px 3px #00000029', borderRadius: '5px' }}
              onClick={() => undefined}
            >
              <div
                style={{
                  backgroundColor: '#F6F9FD',
                  height: '35px',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <span style={{ fontSize: '16px', color: '#3E3E41', paddingLeft: '16px' }}>
                  {driver}
                </span>
              </div>
              <div style={{ display: 'flex', height: '52px' }}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '20%',
                    justifyContent: 'center',
                    paddingLeft: '16px',
                    borderRight: '1px solid #E7E7EC',
                    marginTop: '5px'
                  }}
                >
                  <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Loads</span>
                  <span style={{ fontSize: '16px', color: '#3E3E41', paddingTop: '6px' }}>
                    {loads}
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '20%',
                    justifyContent: 'center',
                    paddingLeft: '16px',
                    borderRight: '1px solid #E7E7EC',
                    marginTop: '5px'
                  }}
                >
                  <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Hauls</span>
                  <span style={{ fontSize: '16px', color: '#3E3E41', paddingTop: '6px' }}>
                    {hauls}
                  </span>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    paddingLeft: '16px',
                    marginTop: '5px',
                    width: '50%'
                  }}
                >
                  <span style={{ fontSize: '12px', color: '#9FA0A5' }}>Driver</span>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-end'
                    }}
                  >
                    <span style={{ fontSize: '16px', color: '#3E3E41' }}>-</span>
                    <ChevronRight style={{ color: 'white' }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      })}
      {props.isForeman && (
        <div
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            zIndex: 1
          }}
        >
          <div
            style={{
              margin: '0 8px 16px 8px',
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%'
            }}
          >
            <div
              style={{
                width: '100%',
                height: '40px',
                background:
                  'transparent linear-gradient(0deg, #1665D8 0%, #1F6FE5 99%, #1F6FE5 100%) 0% 0% no-repeat padding-box',
                boxShadow: '0px 1px 3px #00000029',
                borderRadius: '4px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
              onClick={() => props.setAddTruck(true)}
            >
              <span style={{ color: '#fff' }}>Add Truck</span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default TrucksProduction
